import { useQuery } from '@tanstack/vue-query'
import { gql } from 'graphql-tag'

export function useComplianceScore() {
  const { query } = useGqlMikro()
  const { user } = storeToRefs(useAuthStore())

  return useQuery({
    queryKey: ['compliance-score'],
    queryFn: async () => {
      const { data, errors } = await query({
        query: COMPLIANCE_SCORE,
        variables: { filter: { clientId: user.value.client.id } },
      })

      if (errors) {
        throw new Error(errors[0].message)
      }

      return data.complianceScore
    },
  })
}

export const COMPLIANCE_SCORE = gql`
query ComplianceScore($filter: ComplianceScoreGraphqlFilter!) {
  complianceScore(filter: $filter) {
    category
    completedRequired
    score
    totalRequired
  }
}
`
